import { render } from "./NewProjectPage.vue?vue&type=template&id=162a3f0e&scoped=true"
import script from "./NewProjectPage.vue?vue&type=script&lang=js"
export * from "./NewProjectPage.vue?vue&type=script&lang=js"

import "./NewProjectPage.vue?vue&type=style&index=0&id=162a3f0e&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162a3f0e"]])

export default __exports__